import apiService from './api.service'
import storage from './stoage.service'

// O id chega da rota (props.match.params.id) como string: "12345" vira 12345; "novo", vazio ou
// qualquer outro texto vira null (oid_entity e bigint e o BE recusaria o texto).
const toOidEntity = (oidEntity) => {
  const oid = Number(oidEntity)
  return Number.isSafeInteger(oid) && oid > 0 ? oid : null
}

const logarAcesso = (oidEntity = null) => {
  const path = storage.getMenuPath()
  const oidMenu = storage.getOidCurrentMenu()
  return apiService.post(`/lottustech/logacesso/logar`, {
    path,
    nomeEntity: null,
    oidEntity: toOidEntity(oidEntity),
    oidMenu,
  })
}

export { logarAcesso, toOidEntity }
